import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RadioGroup from 'components/RadioGroup';
import Stepper from 'components/Stepper';
import H1 from 'components/deprecated/legacyElements/H1';
import { update, nextPage } from 'actions/onboarding';
import styles from './style.module.scss';

const EMPLOYEE_SIZES = [
  {
    value: 100,
    name: 'Economy',
    blurb: (
      <p>
        The <strong>economy</strong> office is mostly open with bench seating.
        There are limited conference/meeting rooms.
      </p>
    ),
  },
  {
    value: 150,
    name: 'Average',
    blurb: (
      <p>
        The <strong>average</strong> office tends to allocate more space to
        meeting rooms and open floor desks, less space to private offices.
      </p>
    ),
  },
  {
    value: 200,
    name: 'Spacious',
    blurb: (
      <p>
        The <strong>spacious</strong> office allocates most of the space for
        private offices and meeting rooms.
      </p>
    ),
  },
];

export class SizePage extends PureComponent {
  static propTypes = {
    update: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
    psfPerEmployee: PropTypes.number.isRequired,
    totalSquareFeet: PropTypes.number.isRequired,
    numEmployees: PropTypes.number,
    sizeError: PropTypes.string,
  };

  static defaultProps = {
    numEmployees: undefined,
    sizeError: null,
  };

  updateCount = ({ name, value }) =>
    this.props.update({ [name]: Number(value) });

  updateSize = ({ target: { name, value } }) =>
    this.props.update({
      [name]: Number(value),
      numEmployees: this.props.numEmployees,
    });

  onKeyDown = (evt) => {
    if (evt.keyCode === 0x0d && this.props.numEmployees > 0) {
      // Enter key
      this.props.nextPage();
    }
  };

  render() {
    const selectedSize = EMPLOYEE_SIZES.find(
      (s) => s.value === this.props.psfPerEmployee
    );
    const sizeMultiplier = Math.log(
      1 + (this.props.totalSquareFeet || 0) / 10000
    );
    const fontSize = Math.min(20 + sizeMultiplier * 50, 80);

    return (
      <div>
        {this.props.totalSquareFeet > 0 && (
          <div
            data-qa="onboarding-size-suggestion"
            className={styles.sizeSuggestion}
            style={{ fontSize }}
          >
            <h3>{`~${this.props.totalSquareFeet} sf`}</h3>
            <p style={{ fontSize: 20 }}>Recommended Size</p>
          </div>
        )}

        <H1>Choose a size.</H1>
        <p>How many seats do you need?</p>

        <h3>Number of seats/employees</h3>
        <Stepper
          name="numEmployees"
          value={this.props.numEmployees}
          onChange={this.updateCount}
          onKeyDown={this.onKeyDown}
          max={100000}
        />
        {this.props.numEmployees === 0 && (
          <span className={styles.tooltipContainer}>
            <p className={styles.tooltipOverlay}>
              Enter in a value to get a size estimate
            </p>
          </span>
        )}
        {this.props.sizeError && (
          <p className={styles.sizeError}>{this.props.sizeError}</p>
        )}

        <h3>Space per employee</h3>
        <RadioGroup
          options={EMPLOYEE_SIZES}
          name="psfPerEmployee"
          value={this.props.psfPerEmployee}
          onChange={this.updateSize}
        />
        <aside className={styles.infoAside}>
          <h4>Spacing Information</h4>
          {selectedSize && selectedSize.blurb}
        </aside>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    numEmployees: state.onboarding.numEmployees,
    psfPerEmployee: state.onboarding.psfPerEmployee,
    totalSquareFeet: state.onboarding.totalSquareFeet,
    sizeError: state.onboarding.sizeError,
  }),
  {
    update,
    nextPage,
  }
)(SizePage);
